/* @jsx mdx */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsx mdx */
import { ShaderMaterial } from './InteractiveComponents';
export const metadata = {
  demo: ShaderMaterial,
  title: 'THREE.ShaderMaterial'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`ThreeJS shaders include some built-in uniforms (e.g. `}<inlineCode parentName="p">{`projectionMatrix`}</inlineCode>{`) and attributes (e.g. `}<inlineCode parentName="p">{`position`}</inlineCode>{`, `}<inlineCode parentName="p">{`uv`}</inlineCode>{`), so you don't need to redefine them. You also don't need to write a `}<inlineCode parentName="p">{`precision`}</inlineCode>{` specifier.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
